import React, { useEffect, useState } from 'react'
import { Table, Loader, Header } from 'semantic-ui-react'
import { ActionPlanService } from 'utility/services/action-plan'
import styled from 'styled-components'
import { useParams, useNavigate } from 'react-router-dom'
import { CaretLeft } from 'phosphor-react'
import { FlexRow, FlexRowBetween } from 'components'

const ViewActionPlanContainer = styled.div`
    padding: 20px;
    margin-top: 20px;
`

export const ViewActionPlanScreen = () => {
    const { questionId } = useParams()
    const navigate = useNavigate()
    const [actionPlans, setActionPlans] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchActionPlans = async () => {
            try {
                const response = await ActionPlanService.getByQuestionId(
                    questionId,
                )
                setActionPlans(response)
            } catch (error) {
                console.error('Error fetching action plans:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchActionPlans()
    }, [questionId])

    if (loading) {
        return <Loader active>Loading action plans...</Loader>
    }

    return (
        <ViewActionPlanContainer>
            <Header as="h4" block>
                <FlexRowBetween>
                    <FlexRow
                        onClick={() => navigate(-1)}
                        className="align-items-center pointer"
                    >
                        <CaretLeft size="24" />
                        <div className="ms-2">Back</div>
                    </FlexRow>
                </FlexRowBetween>
            </Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Action Plan ID</Table.HeaderCell>
                        <Table.HeaderCell>Description</Table.HeaderCell>
                        <Table.HeaderCell>Assigned To</Table.HeaderCell>
                        <Table.HeaderCell>Created By</Table.HeaderCell>
                        <Table.HeaderCell>Due Date</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {actionPlans.map(plan => (
                        <Table.Row key={plan.ActionPlanId}>
                            <Table.Cell>{plan.ActionPlanId}</Table.Cell>
                            <Table.Cell>{plan.Description}</Table.Cell>
                            <Table.Cell>{plan.AssignedUser}</Table.Cell>
                            <Table.Cell>{plan.CreatedByUser}</Table.Cell>
                            <Table.Cell>
                                {new Date(plan.DueDate).toLocaleDateString()}
                            </Table.Cell>
                            <Table.Cell>
                                {plan.TicketStatus === 1 ? 'Open' : 'Closed'}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </ViewActionPlanContainer>
    )
}

export default ViewActionPlanScreen
